import React from 'react';
import { FiCalendar, FiFileText, FiClock, FiShield, FiCheckSquare  } from 'react-icons/fi';

export default function ComplianceRecords() {
  // Configurable data array for the compliance rows
  const records = [
    { id: 1, name: 'Allergen Matrix Review', count: 1, icon: FiCalendar },
    { id: 2, name: 'Supplier Allergen Record', count: 1, icon: FiFileText },
    { id: 3, name: 'Training Record', count: 1, icon: FiClock },
    { id: 4, name: 'Allergen Verification Record', count: 1, icon: FiClock },
    { id: 5, name: 'Allergen Incident Record', count: 0, icon: FiShield },
  ];

  // Dynamic summation calculation
  const totalRecords = records.reduce((acc, current) => acc + current.count, 0);

  return (
    <div className="w-[280px] bg-white rounded-2xl p-6 border border-gray-100 shadow-sm font-sans select-none">
      {/* Header section */}
      <div className="mb-6 space-y-2">
        <h3 className="text-gray-900 font-bold text-base tracking-tight text-left">
          Compliance Records
        </h3>
        <p className="text-blue-900/70 text-xs font-normal leading-relaxed text-left">
          Records that will be generated when this check is completed.
        </p>
      </div>

      {/* Dynamic item list */}
      <div className="space-y-4">
        {records.map((item) => {
          const IconComponent = item.icon;
          return (
            <div key={item.id} className="flex items-center justify-between text-sm">
              <div className="flex items-center space-x-3 text-blue-950 font-semibold min-w-0">
                <IconComponent className="w-4 h-4 text-blue-600 flex-shrink-0" />
                <span className="truncate text-left">{item.name}</span>
              </div>
              <span className="font-bold text-gray-900 pl-2">{item.count}</span>
            </div>
          );
        })}

        {/* Total Summary Row */}
        <div className="flex items-center justify-between text-sm pt-4 border-t border-gray-100 mt-2">
          <div className="flex items-center space-x-3 text-blue-600 font-bold">
            <FiCheckSquare  className="w-4 h-4 flex-shrink-0" />
            <span>Total Records</span>
          </div>
          <span className="font-bold text-blue-600">{totalRecords}</span>
        </div>
      </div>
    </div>
  );
}
